module.exports = __webpack_public_path__ + "static/1-fc3c0cc9f8c417f31a684cbe5ce15c49.jpg";